import React, { useState } from "react";
import cn from "classnames";
import Modal from "components/modals/Modal";
import Filters from "../Filters";
import styles from "./styles.module.scss";
import Map from "../Map";

const Toolbar = () => {
  const [showFilters, setShowFilters] = useState(false);
  const [showMap, setShowMap] = useState(false);
  return (
    <div className={styles.toolbar} data-qa="ice-mobile-filters">
      <Filters
        className={cn(styles.filters, { [styles.openFilters]: showFilters })}
      />
      {showMap && (
        <Modal onClose={() => setShowMap(false)}>
          <div className={styles.mapContainer}>
            <Map hoveredListingId={null} />
          </div>
        </Modal>
      )}
      <div className={styles.buttons}>
        <button
          className={cn("btn-primary", styles.leftButton)}
          type="button"
          onClick={() => setShowFilters(!showFilters)}
        >
          <i className="icon icon-sliders" /> Filters
        </button>
        <button
          className={cn("btn-primary", styles.rightButton)}
          type="button"
          onClick={() => setShowMap(!showMap)}
        >
          <i className="icon icon-map" /> Map
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
